import axios from "axios";


export const getOrder= (referenceNumber)=>{
    return axios.get(
        `${process.env.REACT_APP_BASE_URL}api/v1/tracking/?referenceNumber=${referenceNumber}`
      );

}